import { RoutePath } from "#utils/route";
import { FlowListRoute } from "#routes/organization/flows";

export const FlowCreateRoute = FlowListRoute.concat(
  new RoutePath<"mode">({
    path: "/create/:mode",
    title: "Create Flow",
  })
);
